import { ReactNode, useEffect } from 'react'
import { useImmerReducer } from 'use-immer'
import * as amplitude from '@amplitude/unified'

import { SessionContext, initialState } from './session_context'
import { sessionReducer } from './session_reducer'

export type SessionProviderProps = {
  children: ReactNode
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
  const [state, dispatch] = useImmerReducer(sessionReducer, initialState)
  const { Provider } = SessionContext

  useEffect(() => {
    // If the user was restored from storage on init, set Amplitude user ID
    if (state.user?.id) {
      amplitude.setUserId(state.user.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Provider value={{ state, dispatch }}> {children} </Provider>
}
